<div class="logo-bar">
  <div class="intrack-logo"></div>
  <button mat-icon-button (click)="this.appFacade.toggleFullscreenMode()">
    <ui-svg-icon
      class="tw-mr-0"
      [name]="(appFacade.fullscreenMode$ | async) ? iconNameList.FullscreenExit : iconNameList.Fullscreen"
    ></ui-svg-icon>
  </button>
</div>
<ul class="menu">
  <ng-container *ngFor="let menuElement of menuStructure">
    <li *show="menuElement.permission" class="menu-group tw-flex">
      <ng-container *ngIf="!menuElement.children; else menuGroupTemplate">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: menuElement, icon: true }"></ng-container>
      </ng-container>
    </li>

    <ng-template #menuGroupTemplate>
      <mat-expansion-panel
        #expansionPanel
        class="menu-group"
        hideToggle
        [expanded]="
          activeMenuItem$.value !== menuNavigation$.value
            ? menuElement.title === menuNavigation$.value
            : menuElement.title === activeMenuItem$.value
        "
        (click)="menuNavigation$.next(menuElement.title)"
      >
        <mat-expansion-panel-header matRipple [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
          <ng-container
            *ngTemplateOutlet="
              expansionPanelHeaderItem;
              context: {
                $implicit: menuElement,
                expansionPanel: expansionPanel,
                subPanelItem: false
              }
            "
          ></ng-container>
        </mat-expansion-panel-header>

        <ul *ngIf="menuElement.children?.length > 0">
          <ng-container *ngFor="let child of menuElement.children">
            <li *show="child.permission">
              <ng-container *ngIf="!child.children; else menuSubItemsTemplate">
                <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: child }"></ng-container>
              </ng-container>

              <ng-template #menuSubItemsTemplate>
                <mat-accordion>
                  <mat-expansion-panel
                    #expansionPanel
                    class="menu-group"
                    hideToggle
                    [expanded]="child.title === subPanelNavigation$.value"
                    (click)="subPanelNavigation$.next(child.title); $event.stopPropagation()"
                  >
                    <mat-expansion-panel-header matRipple [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
                      <ng-container
                        *ngTemplateOutlet="
                          expansionPanelHeaderItem;
                          context: {
                            $implicit: child,
                            expansionPanel: expansionPanel,
                            subPanelItem: !!child.url
                          }
                        "
                      ></ng-container>
                    </mat-expansion-panel-header>

                    <ul *ngIf="child.children">
                      <li *ngFor="let item of child.children" class="low-level-item">
                        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
                      </li>
                    </ul>
                  </mat-expansion-panel>
                </mat-accordion>
              </ng-template>
            </li>
          </ng-container>
        </ul>
      </mat-expansion-panel>
    </ng-template>
  </ng-container>
</ul>

<ng-template #itemTemplate let-item let-icon="icon">
  <ng-container *show="item.permission">
    <a
      *ngIf="item.url; else externalUrlTemplate"
      class="menu-item menu-item--sub"
      [routerLink]="item.url"
      [routerLinkActive]="item.url ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: true }"
      mat-menu-item
    >
      <ui-svg-icon *ngIf="icon" class="tw-self-center" [name]="item.icon"></ui-svg-icon>
      {{ item.title | translate }}
    </a>
  </ng-container>

  <ng-template #externalUrlTemplate>
    <a
      *ngIf="item.externalUrl"
      class="menu-item menu-item--sub"
      [href]="item.externalUrl"
      target="_blank"
      mat-menu-item
    >
      <ui-svg-icon *ngIf="icon" class="tw-self-center" [name]="item.icon"></ui-svg-icon>
      {{ item.title | translate }}
    </a>
  </ng-template>
</ng-template>

<ng-template #expansionPanelHeaderItem let-item let-expansionPanel="expansionPanel" let-subPanelItem="subPanelItem">
  <div class="menu-item-group tw-flex tw-justify-between">
    <ng-container [ngSwitch]="subPanelItem">
      <ng-container *ngSwitchCase="false">
        <a class="menu-item__link" [ngClass]="{ 'tw-pl-[46px]': !item.icon }">
          <ui-svg-icon *ngIf="item.icon" class="tw-self-center" [name]="item.icon"></ui-svg-icon>
          {{ item.title | translate }}
        </a>
      </ng-container>

      <ng-container *ngSwitchCase="true">
        <a
          class="menu-item__link"
          [class.menu-item__subitem]="subPanelItem"
          [routerLink]="item.url"
          [routerLinkActive]="item.url ? 'active' : ''"
          (click)="subPanelNavigation$.next(''); $event.stopPropagation()"
          mat-menu-item
        >
          {{ item.title | translate }}
        </a>
      </ng-container>
    </ng-container>

    <ui-svg-icon
      *ngIf="item.children?.length"
      class="dropdown-icon tw-self-center"
      [width]="18"
      [name]="expansionPanel.expanded ? iconNameList.Up : iconNameList.Down"
    >
    </ui-svg-icon>
  </div>
</ng-template>
